<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style lang="less">
@import "./styles/reset.css";

#app {
  height: 100vh;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue